//1st bar
import { useEffect } from 'react'

export default function BarPlot() {
  useEffect(() => {
    window.PLOTLYENV = window.PLOTLYENV || {}
    if (document.getElementById('b11f0f47-2e59-4999-9e02-033b24e03057')) {
      window.Plotly.newPlot(
        'b11f0f47-2e59-4999-9e02-033b24e03057',
        [
          {
            alignmentgroup: 'True',
            customdata: [['North Korea', 2500]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['North Korea'],
            legendgroup: 'North Korea',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'North Korea',
            offsetgroup: 'North Korea',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [2500.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Oman', 15830]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Oman'],
            legendgroup: 'Oman',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Oman',
            offsetgroup: 'Oman',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [1439.090909090909],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Kuwait', 10120]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Kuwait'],
            legendgroup: 'Kuwait',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Kuwait',
            offsetgroup: 'Kuwait',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [1265.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Morocco', 14562]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Morocco'],
            legendgroup: 'Morocco',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Morocco',
            offsetgroup: 'Morocco',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [539.3333333333334],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Afghanistan', 3255]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Afghanistan'],
            legendgroup: 'Afghanistan',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Afghanistan',
            offsetgroup: 'Afghanistan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [406.875],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['United Arab Emirates', 6570]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['United Arab Emirates'],
            legendgroup: 'United Arab Emirates',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'United Arab Emirates',
            offsetgroup: 'United Arab Emirates',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [386.47058823529414],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Iraq', 6045]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Iraq'],
            legendgroup: 'Iraq',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Iraq',
            offsetgroup: 'Iraq',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [302.25],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Libya', 600]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Libya'],
            legendgroup: 'Libya',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Libya',
            offsetgroup: 'Libya',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [300.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Finland', 580]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Finland'],
            legendgroup: 'Finland',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Finland',
            offsetgroup: 'Finland',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [290.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Western Sahara', 1105]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Western Sahara'],
            legendgroup: 'Western Sahara',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Western Sahara',
            offsetgroup: 'Western Sahara',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [276.25],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Qatar', 815]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Qatar'],
            legendgroup: 'Qatar',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Qatar',
            offsetgroup: 'Qatar',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [271.6666666666667],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Ethiopia', 1350]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Ethiopia'],
            legendgroup: 'Ethiopia',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Ethiopia',
            offsetgroup: 'Ethiopia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [270.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Serbia', 2037]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Serbia'],
            legendgroup: 'Serbia',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Serbia',
            offsetgroup: 'Serbia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [254.625],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Australia', 62146]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Australia'],
            legendgroup: 'Australia',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Australia',
            offsetgroup: 'Australia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Oceania'],
            xaxis: 'x',
            y: [239.02307692307693],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Uzbekistan', 1828]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Uzbekistan'],
            legendgroup: 'Uzbekistan',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Uzbekistan',
            offsetgroup: 'Uzbekistan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [228.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Saudi Arabia', 5166]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Saudi Arabia'],
            legendgroup: 'Saudi Arabia',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Saudi Arabia',
            offsetgroup: 'Saudi Arabia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [224.6086956521739],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Myanmar', 7610]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Myanmar'],
            legendgroup: 'Myanmar',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Myanmar',
            offsetgroup: 'Myanmar',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [223.8235294117647],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Indonesia', 3215]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Indonesia'],
            legendgroup: 'Indonesia',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Indonesia',
            offsetgroup: 'Indonesia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [214.33333333333334],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Sri Lanka', 1270]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Sri Lanka'],
            legendgroup: 'Sri Lanka',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Sri Lanka',
            offsetgroup: 'Sri Lanka',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [211.66666666666666],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['DR Congo', 740]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['DR Congo'],
            legendgroup: 'DR Congo',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'DR Congo',
            offsetgroup: 'DR Congo',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [185.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['South Korea', 3597]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['South Korea'],
            legendgroup: 'South Korea',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'South Korea',
            offsetgroup: 'South Korea',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [179.85],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Laos', 304]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Laos'],
            legendgroup: 'Laos',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Laos',
            offsetgroup: 'Laos',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [152.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Iran', 2070]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Iran'],
            legendgroup: 'Iran',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Iran',
            offsetgroup: 'Iran',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [147.85714285714286],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Chile', 16224]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Chile'],
            legendgroup: 'Chile',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Chile',
            offsetgroup: 'Chile',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [146.16216216216216],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Algeria', 5488]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Algeria'],
            legendgroup: 'Algeria',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Algeria',
            offsetgroup: 'Algeria',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [140.71794871794873],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['India', 62675]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['India'],
            legendgroup: 'India',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'India',
            offsetgroup: 'India',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [132.22573839662448],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Armenia', 255]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Armenia'],
            legendgroup: 'Armenia',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Armenia',
            offsetgroup: 'Armenia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Eurasia'],
            xaxis: 'x',
            y: [127.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Turkey', 1907]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Turkey'],
            legendgroup: 'Turkey',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Turkey',
            offsetgroup: 'Turkey',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Eurasia'],
            xaxis: 'x',
            y: [127.13333333333334],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Azerbaijan', 250]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Azerbaijan'],
            legendgroup: 'Azerbaijan',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Azerbaijan',
            offsetgroup: 'Azerbaijan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Eurasia'],
            xaxis: 'x',
            y: [125.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Uganda', 1107]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Uganda'],
            legendgroup: 'Uganda',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Uganda',
            offsetgroup: 'Uganda',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [123.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Taiwan', 1715]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Taiwan'],
            legendgroup: 'Taiwan',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Taiwan',
            offsetgroup: 'Taiwan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [122.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Togo', 470]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Togo'],
            legendgroup: 'Togo',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Togo',
            offsetgroup: 'Togo',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [117.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['United States', 160378]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['United States'],
            legendgroup: 'United States',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'United States',
            offsetgroup: 'United States',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['North America'],
            xaxis: 'x',
            y: [108.51014884979702],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Colombia', 19074]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Colombia'],
            legendgroup: 'Colombia',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Colombia',
            offsetgroup: 'Colombia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [106.55865921787709],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Montenegro', 312]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Montenegro'],
            legendgroup: 'Montenegro',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Montenegro',
            offsetgroup: 'Montenegro',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [104.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Thailand', 2065]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Thailand'],
            legendgroup: 'Thailand',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Thailand',
            offsetgroup: 'Thailand',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [103.25],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['New Zealand', 1238]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['New Zealand'],
            legendgroup: 'New Zealand',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'New Zealand',
            offsetgroup: 'New Zealand',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Oceania'],
            xaxis: 'x',
            y: [103.16666666666667],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Zambia', 1123]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Zambia'],
            legendgroup: 'Zambia',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Zambia',
            offsetgroup: 'Zambia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [102.0909090909091],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Spain', 20606]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Spain'],
            legendgroup: 'Spain',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Spain',
            offsetgroup: 'Spain',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [101.50738916256158],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Eswatini', 100]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Eswatini'],
            legendgroup: 'Eswatini',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Eswatini',
            offsetgroup: 'Eswatini',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [100.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Holy See', 200]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Holy See'],
            legendgroup: 'Holy See',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Holy See',
            offsetgroup: 'Holy See',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [100.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Georgia', 100]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Georgia'],
            legendgroup: 'Georgia',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Georgia',
            offsetgroup: 'Georgia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Eurasia'],
            xaxis: 'x',
            y: [100.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bahrain', 100]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bahrain'],
            legendgroup: 'Bahrain',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bahrain',
            offsetgroup: 'Bahrain',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [100.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Nigeria', 1577]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Nigeria'],
            legendgroup: 'Nigeria',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Nigeria',
            offsetgroup: 'Nigeria',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [98.5625],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Syria', 490]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Syria'],
            legendgroup: 'Syria',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Syria',
            offsetgroup: 'Syria',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [98.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['North Macedonia', 860]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['North Macedonia'],
            legendgroup: 'North Macedonia',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'North Macedonia',
            offsetgroup: 'North Macedonia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [95.55555555555556],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['South Africa', 4742]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['South Africa'],
            legendgroup: 'South Africa',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'South Africa',
            offsetgroup: 'South Africa',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [94.84],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Belarus', 185]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Belarus'],
            legendgroup: 'Belarus',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Belarus',
            offsetgroup: 'Belarus',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [92.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Philippines', 11696]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Philippines'],
            legendgroup: 'Philippines',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Philippines',
            offsetgroup: 'Philippines',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [92.09448818897638],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bulgaria', 1375]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bulgaria'],
            legendgroup: 'Bulgaria',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bulgaria',
            offsetgroup: 'Bulgaria',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [91.66666666666667],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Vietnam', 16572]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Vietnam'],
            legendgroup: 'Vietnam',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Vietnam',
            offsetgroup: 'Vietnam',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [90.06521739130434],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Kosovo', 180]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Kosovo'],
            legendgroup: 'Kosovo',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Kosovo',
            offsetgroup: 'Kosovo',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [90.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Poland', 1153]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Poland'],
            legendgroup: 'Poland',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Poland',
            offsetgroup: 'Poland',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [88.6923076923077],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Portugal', 2919]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Portugal'],
            legendgroup: 'Portugal',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Portugal',
            offsetgroup: 'Portugal',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [88.45454545454545],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Mexico', 21269]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Mexico'],
            legendgroup: 'Mexico',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Mexico',
            offsetgroup: 'Mexico',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['North America'],
            xaxis: 'x',
            y: [87.88842975206612],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Zimbabwe', 2450]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Zimbabwe'],
            legendgroup: 'Zimbabwe',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Zimbabwe',
            offsetgroup: 'Zimbabwe',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [84.48275862068965],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Peru', 904]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Peru'],
            legendgroup: 'Peru',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Peru',
            offsetgroup: 'Peru',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [82.18181818181819],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Greece', 43158]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Greece'],
            legendgroup: 'Greece',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Greece',
            offsetgroup: 'Greece',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [82.04942965779468],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Ireland', 560]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Ireland'],
            legendgroup: 'Ireland',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Ireland',
            offsetgroup: 'Ireland',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [80.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Albania', 640]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Albania'],
            legendgroup: 'Albania',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Albania',
            offsetgroup: 'Albania',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [80.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Pakistan', 3515]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Pakistan'],
            legendgroup: 'Pakistan',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Pakistan',
            offsetgroup: 'Pakistan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [78.11111111111111],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Israel', 857]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Israel'],
            legendgroup: 'Israel',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Israel',
            offsetgroup: 'Israel',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [77.9090909090909],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['France', 2489]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['France'],
            legendgroup: 'France',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'France',
            offsetgroup: 'France',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [77.78125],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Egypt', 4073]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Egypt'],
            legendgroup: 'Egypt',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Egypt',
            offsetgroup: 'Egypt',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [76.84905660377359],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bangladesh', 3760]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bangladesh'],
            legendgroup: 'Bangladesh',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bangladesh',
            offsetgroup: 'Bangladesh',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [76.73469387755102],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Hong Kong', 230]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Hong Kong'],
            legendgroup: 'Hong Kong',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Hong Kong',
            offsetgroup: 'Hong Kong',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [76.66666666666667],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Ghana', 1752]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Ghana'],
            legendgroup: 'Ghana',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Ghana',
            offsetgroup: 'Ghana',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [76.17391304347827],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Argentina', 1364]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Argentina'],
            legendgroup: 'Argentina',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Argentina',
            offsetgroup: 'Argentina',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [75.77777777777777],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Chad', 742]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Chad'],
            legendgroup: 'Chad',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Chad',
            offsetgroup: 'Chad',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [74.2],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Gabon', 370]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Gabon'],
            legendgroup: 'Gabon',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Gabon',
            offsetgroup: 'Gabon',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [74.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Denmark', 1471]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Denmark'],
            legendgroup: 'Denmark',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Denmark',
            offsetgroup: 'Denmark',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [73.55],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Tanzania', 210]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Tanzania'],
            legendgroup: 'Tanzania',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Tanzania',
            offsetgroup: 'Tanzania',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [70.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Malaysia', 2766]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Malaysia'],
            legendgroup: 'Malaysia',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Malaysia',
            offsetgroup: 'Malaysia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [62.86363636363637],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Tunisia', 1000]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Tunisia'],
            legendgroup: 'Tunisia',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Tunisia',
            offsetgroup: 'Tunisia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [62.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Singapore', 559]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Singapore'],
            legendgroup: 'Singapore',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Singapore',
            offsetgroup: 'Singapore',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [62.111111111111114],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Italy', 2468]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Italy'],
            legendgroup: 'Italy',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Italy',
            offsetgroup: 'Italy',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [61.7],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Panama', 177]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Panama'],
            legendgroup: 'Panama',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Panama',
            offsetgroup: 'Panama',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [59.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Dominican Republic', 765]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Dominican Republic'],
            legendgroup: 'Dominican Republic',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Dominican Republic',
            offsetgroup: 'Dominican Republic',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [58.84615384615385],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Romania', 1353]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Romania'],
            legendgroup: 'Romania',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Romania',
            offsetgroup: 'Romania',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [58.82608695652174],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Jordan', 1731]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Jordan'],
            legendgroup: 'Jordan',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Jordan',
            offsetgroup: 'Jordan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Middle East'],
            xaxis: 'x',
            y: [57.7],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Angola', 460]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Angola'],
            legendgroup: 'Angola',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Angola',
            offsetgroup: 'Angola',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [57.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Cuba', 114]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Cuba'],
            legendgroup: 'Cuba',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Cuba',
            offsetgroup: 'Cuba',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [57.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['The Gambia', 170]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['The Gambia'],
            legendgroup: 'The Gambia',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'The Gambia',
            offsetgroup: 'The Gambia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [56.666666666666664],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Canada', 2589]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Canada'],
            legendgroup: 'Canada',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Canada',
            offsetgroup: 'Canada',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['North America'],
            xaxis: 'x',
            y: [56.28260869565217],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bosnia and Herzegovina', 786]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bosnia and Herzegovina'],
            legendgroup: 'Bosnia and Herzegovina',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bosnia and Herzegovina',
            offsetgroup: 'Bosnia and Herzegovina',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [56.142857142857146],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Trinidad and Tobago', 112]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Trinidad and Tobago'],
            legendgroup: 'Trinidad and Tobago',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Trinidad and Tobago',
            offsetgroup: 'Trinidad and Tobago',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [56.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['French Guiana', 55]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['French Guiana'],
            legendgroup: 'French Guiana',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'French Guiana',
            offsetgroup: 'French Guiana',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [55.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Ukraine', 1837]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Ukraine'],
            legendgroup: 'Ukraine',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Ukraine',
            offsetgroup: 'Ukraine',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [54.029411764705884],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bolivia', 160]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bolivia'],
            legendgroup: 'Bolivia',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bolivia',
            offsetgroup: 'Bolivia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [53.333333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Bhutan', 320]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Bhutan'],
            legendgroup: 'Bhutan',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Bhutan',
            offsetgroup: 'Bhutan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [53.333333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Brazil', 36329]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Brazil'],
            legendgroup: 'Brazil',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Brazil',
            offsetgroup: 'Brazil',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [53.11257309941521],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['El Salvador', 265]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['El Salvador'],
            legendgroup: 'El Salvador',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'El Salvador',
            offsetgroup: 'El Salvador',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [53.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['China', 139994]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['China'],
            legendgroup: 'China',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'China',
            offsetgroup: 'China',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [51.186106032906764],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Germany', 4433]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Germany'],
            legendgroup: 'Germany',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Germany',
            offsetgroup: 'Germany',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [50.375],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Kazakhstan', 1603]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Kazakhstan'],
            legendgroup: 'Kazakhstan',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Kazakhstan',
            offsetgroup: 'Kazakhstan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [50.09375],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Botswana', 200]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Botswana'],
            legendgroup: 'Botswana',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Botswana',
            offsetgroup: 'Botswana',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [50.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Croatia', 1774]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Croatia'],
            legendgroup: 'Croatia',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Croatia',
            offsetgroup: 'Croatia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [49.27777777777778],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Cambodia', 635]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Cambodia'],
            legendgroup: 'Cambodia',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Cambodia',
            offsetgroup: 'Cambodia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [48.84615384615385],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Djibouti', 530]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Djibouti'],
            legendgroup: 'Djibouti',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Djibouti',
            offsetgroup: 'Djibouti',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [48.18181818181818],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Mozambique', 481]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Mozambique'],
            legendgroup: 'Mozambique',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Mozambique',
            offsetgroup: 'Mozambique',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [48.1],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Mali', 426]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Mali'],
            legendgroup: 'Mali',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Mali',
            offsetgroup: 'Mali',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [47.333333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Belgium', 233]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Belgium'],
            legendgroup: 'Belgium',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Belgium',
            offsetgroup: 'Belgium',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [46.6],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Guatemala', 93]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Guatemala'],
            legendgroup: 'Guatemala',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Guatemala',
            offsetgroup: 'Guatemala',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [46.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Namibia', 272]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Namibia'],
            legendgroup: 'Namibia',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Namibia',
            offsetgroup: 'Namibia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [45.333333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Netherlands', 1392]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Netherlands'],
            legendgroup: 'Netherlands',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Netherlands',
            offsetgroup: 'Netherlands',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [44.903225806451616],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Ecuador', 955]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Ecuador'],
            legendgroup: 'Ecuador',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Ecuador',
            offsetgroup: 'Ecuador',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [43.40909090909091],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Japan', 10535]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Japan'],
            legendgroup: 'Japan',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Japan',
            offsetgroup: 'Japan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [43.17622950819672],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Kenya', 674]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Kenya'],
            legendgroup: 'Kenya',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Kenya',
            offsetgroup: 'Kenya',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [42.125],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Slovakia', 83]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Slovakia'],
            legendgroup: 'Slovakia',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Slovakia',
            offsetgroup: 'Slovakia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [41.5],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Guinea', 122]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Guinea'],
            legendgroup: 'Guinea',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Guinea',
            offsetgroup: 'Guinea',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [40.666666666666664],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Cameroon', 122]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Cameroon'],
            legendgroup: 'Cameroon',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Cameroon',
            offsetgroup: 'Cameroon',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [40.666666666666664],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Niger', 80]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Niger'],
            legendgroup: 'Niger',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Niger',
            offsetgroup: 'Niger',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [40.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Nicaragua', 280]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Nicaragua'],
            legendgroup: 'Nicaragua',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Nicaragua',
            offsetgroup: 'Nicaragua',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [40.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['United Kingdom', 10255]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['United Kingdom'],
            legendgroup: 'United Kingdom',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'United Kingdom',
            offsetgroup: 'United Kingdom',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [39.748062015503876],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Guam', 236]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Guam'],
            legendgroup: 'Guam',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Guam',
            offsetgroup: 'Guam',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Oceania'],
            xaxis: 'x',
            y: [39.333333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Honduras', 572]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Honduras'],
            legendgroup: 'Honduras',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Honduras',
            offsetgroup: 'Honduras',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [38.13333333333333],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Uruguay', 190]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Uruguay'],
            legendgroup: 'Uruguay',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Uruguay',
            offsetgroup: 'Uruguay',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['South America'],
            xaxis: 'x',
            y: [38.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Saint Kitts and Nevis', 38]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Saint Kitts and Nevis'],
            legendgroup: 'Saint Kitts and Nevis',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Saint Kitts and Nevis',
            offsetgroup: 'Saint Kitts and Nevis',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [38.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Jamaica', 263]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Jamaica'],
            legendgroup: 'Jamaica',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Jamaica',
            offsetgroup: 'Jamaica',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [37.57142857142857],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Puerto Rico', 591]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Puerto Rico'],
            legendgroup: 'Puerto Rico',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Puerto Rico',
            offsetgroup: 'Puerto Rico',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [36.9375],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Malawi', 221]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Malawi'],
            legendgroup: 'Malawi',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Malawi',
            offsetgroup: 'Malawi',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [36.833333333333336],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Maldives', 36]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Maldives'],
            legendgroup: 'Maldives',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Maldives',
            offsetgroup: 'Maldives',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [36.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [["C\u00f4te d'Ivoire", 234]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ["C\u00f4te d'Ivoire"],
            legendgroup: "C\u00f4te d'Ivoire",
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: "C\u00f4te d'Ivoire",
            offsetgroup: "C\u00f4te d'Ivoire",
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [33.42857142857143],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Russia', 1423]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Russia'],
            legendgroup: 'Russia',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Russia',
            offsetgroup: 'Russia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Eurasia'],
            xaxis: 'x',
            y: [33.093023255813954],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Sierra Leone', 95]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Sierra Leone'],
            legendgroup: 'Sierra Leone',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Sierra Leone',
            offsetgroup: 'Sierra Leone',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [31.666666666666668],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Mauritania', 95]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Mauritania'],
            legendgroup: 'Mauritania',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Mauritania',
            offsetgroup: 'Mauritania',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [31.666666666666668],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Hungary', 334]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Hungary'],
            legendgroup: 'Hungary',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Hungary',
            offsetgroup: 'Hungary',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [30.363636363636363],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Haiti', 90]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Haiti'],
            legendgroup: 'Haiti',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Haiti',
            offsetgroup: 'Haiti',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [30.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Lesotho', 90]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Lesotho'],
            legendgroup: 'Lesotho',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Lesotho',
            offsetgroup: 'Lesotho',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [30.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Kyrgyzstan', 30]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Kyrgyzstan'],
            legendgroup: 'Kyrgyzstan',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Kyrgyzstan',
            offsetgroup: 'Kyrgyzstan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [30.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['New Caledonia', 30]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['New Caledonia'],
            legendgroup: 'New Caledonia',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'New Caledonia',
            offsetgroup: 'New Caledonia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Oceania'],
            xaxis: 'x',
            y: [30.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Brunei', 30]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Brunei'],
            legendgroup: 'Brunei',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Brunei',
            offsetgroup: 'Brunei',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [30.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Burkina Faso', 264]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Burkina Faso'],
            legendgroup: 'Burkina Faso',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Burkina Faso',
            offsetgroup: 'Burkina Faso',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [29.333333333333332],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Czech Republic', 87]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Czech Republic'],
            legendgroup: 'Czech Republic',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Czech Republic',
            offsetgroup: 'Czech Republic',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [29.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Senegal', 242]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Senegal'],
            legendgroup: 'Senegal',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Senegal',
            offsetgroup: 'Senegal',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [26.88888888888889],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Central African Republic', 25]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Central African Republic'],
            legendgroup: 'Central African Republic',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Central African Republic',
            offsetgroup: 'Central African Republic',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [25.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Benin', 50]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Benin'],
            legendgroup: 'Benin',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Benin',
            offsetgroup: 'Benin',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [25.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Nepal', 25]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Nepal'],
            legendgroup: 'Nepal',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Nepal',
            offsetgroup: 'Nepal',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [25.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Austria', 24]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Austria'],
            legendgroup: 'Austria',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Austria',
            offsetgroup: 'Austria',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [24.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Mongolia', 70]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Mongolia'],
            legendgroup: 'Mongolia',
            marker: {
              color: 'rgb(44,255,150)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Mongolia',
            offsetgroup: 'Mongolia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Asia'],
            xaxis: 'x',
            y: [23.333333333333332],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Sweden', 46]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Sweden'],
            legendgroup: 'Sweden',
            marker: {
              color: 'rgb(0,152,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Sweden',
            offsetgroup: 'Sweden',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Europe'],
            xaxis: 'x',
            y: [23.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Guinea-Bissau', 20]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Guinea-Bissau'],
            legendgroup: 'Guinea-Bissau',
            marker: {
              color: 'rgb(0,25,255)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Guinea-Bissau',
            offsetgroup: 'Guinea-Bissau',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [20.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Barbados', 20]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Barbados'],
            legendgroup: 'Barbados',
            marker: {
              color: 'rgb(0,0,200)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Barbados',
            offsetgroup: 'Barbados',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Central America and the Caribbean'],
            xaxis: 'x',
            y: [20.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Liberia', 20]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Liberia'],
            legendgroup: 'Liberia',
            marker: {
              color: 'rgb(150,0,90)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Liberia',
            offsetgroup: 'Liberia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [20.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Madagascar', 40]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Madagascar'],
            legendgroup: 'Madagascar',
            marker: {
              color: 'rgb(255,0,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Madagascar',
            offsetgroup: 'Madagascar',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [20.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['South Sudan', 20]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['South Sudan'],
            legendgroup: 'South Sudan',
            marker: {
              color: 'rgb(255,111,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'South Sudan',
            offsetgroup: 'South Sudan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [20.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Sudan', 10]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Sudan'],
            legendgroup: 'Sudan',
            marker: {
              color: 'rgb(255,234,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Sudan',
            offsetgroup: 'Sudan',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [10.0],
            yaxis: 'y',
            type: 'bar',
          },
          {
            alignmentgroup: 'True',
            customdata: [['Somalia', 10]],
            hovertemplate:
              '<b>Country:</b> %{customdata[0]}<br><br>Average Capacity (MW): %{y}<br>All-farms Total Capacity (MW): %{customdata[1]}<br>Region: %{x}',
            hovertext: ['Somalia'],
            legendgroup: 'Somalia',
            marker: {
              color: 'rgb(151,255,0)',
              opacity: 0.85,
              pattern: { shape: '' },
            },
            name: 'Somalia',
            offsetgroup: 'Somalia',
            orientation: 'v',
            showlegend: true,
            textposition: 'auto',
            x: ['Africa'],
            xaxis: 'x',
            y: [10.0],
            yaxis: 'y',
            type: 'bar',
          },
        ],
        {
          template: {
            data: {
              bar: [
                {
                  error_x: { color: '#2a3f5f' },
                  error_y: { color: '#2a3f5f' },
                  marker: {
                    line: { color: '#E5ECF6', width: 0.5 },
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'bar',
                },
              ],
              barpolar: [
                {
                  marker: {
                    line: { color: '#E5ECF6', width: 0.5 },
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'barpolar',
                },
              ],
              carpet: [
                {
                  aaxis: {
                    endlinecolor: '#2a3f5f',
                    gridcolor: 'white',
                    linecolor: 'white',
                    minorgridcolor: 'white',
                    startlinecolor: '#2a3f5f',
                  },
                  baxis: {
                    endlinecolor: '#2a3f5f',
                    gridcolor: 'white',
                    linecolor: 'white',
                    minorgridcolor: 'white',
                    startlinecolor: '#2a3f5f',
                  },
                  type: 'carpet',
                },
              ],
              choropleth: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  type: 'choropleth',
                },
              ],
              contour: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'contour',
                },
              ],
              contourcarpet: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  type: 'contourcarpet',
                },
              ],
              heatmap: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'heatmap',
                },
              ],
              heatmapgl: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'heatmapgl',
                },
              ],
              histogram: [
                {
                  marker: {
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'histogram',
                },
              ],
              histogram2d: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'histogram2d',
                },
              ],
              histogram2dcontour: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'histogram2dcontour',
                },
              ],
              mesh3d: [
                { colorbar: { outlinewidth: 0, ticks: '' }, type: 'mesh3d' },
              ],
              parcoords: [
                {
                  line: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'parcoords',
                },
              ],
              pie: [{ automargin: true, type: 'pie' }],
              scatter: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scatter',
                },
              ],
              scatter3d: [
                {
                  line: { colorbar: { outlinewidth: 0, ticks: '' } },
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scatter3d',
                },
              ],
              scattercarpet: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scattercarpet',
                },
              ],
              scattergeo: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scattergeo',
                },
              ],
              scattergl: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scattergl',
                },
              ],
              scattermapbox: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scattermapbox',
                },
              ],
              scatterpolar: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scatterpolar',
                },
              ],
              scatterpolargl: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scatterpolargl',
                },
              ],
              scatterternary: [
                {
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                  type: 'scatterternary',
                },
              ],
              surface: [
                {
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                  type: 'surface',
                },
              ],
              table: [
                {
                  cells: {
                    fill: { color: '#EBF0F8' },
                    line: { color: 'white' },
                  },
                  header: {
                    fill: { color: '#C8D4E3' },
                    line: { color: 'white' },
                  },
                  type: 'table',
                },
              ],
            },
            layout: {
              annotationdefaults: {
                arrowcolor: '#2a3f5f',
                arrowhead: 0,
                arrowwidth: 1,
              },
              autotypenumbers: 'strict',
              coloraxis: { colorbar: { outlinewidth: 0, ticks: '' } },
              colorscale: {
                diverging: [
                  [0, '#8e0152'],
                  [0.1, '#c51b7d'],
                  [0.2, '#de77ae'],
                  [0.3, '#f1b6da'],
                  [0.4, '#fde0ef'],
                  [0.5, '#f7f7f7'],
                  [0.6, '#e6f5d0'],
                  [0.7, '#b8e186'],
                  [0.8, '#7fbc41'],
                  [0.9, '#4d9221'],
                  [1, '#276419'],
                ],
                sequential: [
                  [0.0, '#0d0887'],
                  [0.1111111111111111, '#46039f'],
                  [0.2222222222222222, '#7201a8'],
                  [0.3333333333333333, '#9c179e'],
                  [0.4444444444444444, '#bd3786'],
                  [0.5555555555555556, '#d8576b'],
                  [0.6666666666666666, '#ed7953'],
                  [0.7777777777777778, '#fb9f3a'],
                  [0.8888888888888888, '#fdca26'],
                  [1.0, '#f0f921'],
                ],
                sequentialminus: [
                  [0.0, '#0d0887'],
                  [0.1111111111111111, '#46039f'],
                  [0.2222222222222222, '#7201a8'],
                  [0.3333333333333333, '#9c179e'],
                  [0.4444444444444444, '#bd3786'],
                  [0.5555555555555556, '#d8576b'],
                  [0.6666666666666666, '#ed7953'],
                  [0.7777777777777778, '#fb9f3a'],
                  [0.8888888888888888, '#fdca26'],
                  [1.0, '#f0f921'],
                ],
              },
              colorway: [
                '#636efa',
                '#EF553B',
                '#00cc96',
                '#ab63fa',
                '#FFA15A',
                '#19d3f3',
                '#FF6692',
                '#B6E880',
                '#FF97FF',
                '#FECB52',
              ],
              font: { color: '#2a3f5f' },
              geo: {
                bgcolor: 'white',
                lakecolor: 'white',
                landcolor: '#E5ECF6',
                showlakes: true,
                showland: true,
                subunitcolor: 'white',
              },
              hoverlabel: { align: 'left' },
              hovermode: 'closest',
              mapbox: { style: 'light' },
              paper_bgcolor: 'white',
              plot_bgcolor: '#E5ECF6',
              polar: {
                angularaxis: {
                  gridcolor: 'white',
                  linecolor: 'white',
                  ticks: '',
                },
                bgcolor: '#E5ECF6',
                radialaxis: {
                  gridcolor: 'white',
                  linecolor: 'white',
                  ticks: '',
                },
              },
              scene: {
                xaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  gridwidth: 2,
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                },
                yaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  gridwidth: 2,
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                },
                zaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  gridwidth: 2,
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                },
              },
              shapedefaults: { line: { color: '#2a3f5f' } },
              ternary: {
                aaxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
                baxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
                bgcolor: '#E5ECF6',
                caxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
              },
              title: { x: 0.05 },
              xaxis: {
                automargin: true,
                gridcolor: 'white',
                linecolor: 'white',
                ticks: '',
                title: { standoff: 15 },
                zerolinecolor: 'white',
                zerolinewidth: 2,
              },
              yaxis: {
                automargin: true,
                gridcolor: 'white',
                linecolor: 'white',
                ticks: '',
                title: { standoff: 15 },
                zerolinecolor: 'white',
                zerolinewidth: 2,
              },
            },
          },
          xaxis: {
            anchor: 'y',
            domain: [0.0, 1.0],
            title: { text: 'Region' },
            showspikes: true,
            spikesnap: 'cursor',
            spikethickness: 2,
          },
          yaxis: {
            anchor: 'x',
            domain: [0.0, 1.0],
            title: { text: 'Average Capacity (MW)' },
            showspikes: true,
            spikesnap: 'cursor',
            spikethickness: 2,
          },
          legend: { title: { text: 'Country' }, tracegroupgap: 0 },
          title: {
            text: 'Average Capacity per Region, Divided by Countries',
            font: { size: 22 },
          },
          barmode: 'stack',
          height: 700,
          // width: 975,
          font: { size: 14 },
          uniformtext: { mode: 'hide' },
          spikedistance: 1000,
          hoverdistance: 100,
        },
        { responsive: true },
      )
    }
  }, [])

  return (
    <div
      id='b11f0f47-2e59-4999-9e02-033b24e03057'
      className='plotly-graph-div'
      style={{ height: '700px', width: '100%', margin: 'auto' }}
    ></div>
  )
}
